<template>
  <div class="playlist">
    <div class="go-back fa fa-history" @click="$router.go(-1)">返回</div>
    <!-- {{$route.query.id}} -->
    <template v-if="playlist">
      <SongDetai :play-detai="playlist"></SongDetai>
    </template>
    <hr />

    <h4 class="slist">歌单列表</h4>
    <!-- 歌单列表 -->
    <ul class="songlist">
      <template v-if="playlist">
        <SongListItem
          v-for="(item, index) in playlist.tracks"
          :key="index"
          :song-item="item"
          :is-show-quality="false"
          :index="index"
          @translate-currentid="$emit('translate-currentid', $event)"
        />
      </template>
    </ul>

    <!-- 评论 -->
    <template v-if="playlist">
      <h3>最新评论</h3>
      <HotCom
        :hot-say="item"
        v-for="(item, index) in hotcom"
        :key="index"
      ></HotCom>
    </template>
  </div>
</template>

<script>
import SongListItem from "@/components/SongListItem.vue";
import SongDetai from "@/components/SongDetai.vue";
import HotCom from "@/components/HotCom.vue";

export default {
  // props:["playItem"],
  components: {
    SongListItem,
    SongDetai,
    HotCom
  },
  data: function() {
    return {
      // playlistId:null,
      playlist: null,
      hotcom: []
    };
  },
  methods: {
    // 获取详情数据
    getPlayListDetail(id) {
      this.axios
        .get("http://musicapi.leanapp.cn/playlist/detail", {
          params: {
            id: id
          }
        })
        .then(reponse => {
          // window.console.log(reponse.data)
          ({ playlist: this.playlist } = reponse.data);
        });
    },

    // 获取评论
    getComment(id) {
      this.axios
        .get("http://musicapi.leanapp.cn/comment/playlist", {
          params: {
            id: id
          }
        })
        .then(reponse => {
          // window.console.log(reponse.data);
          ({ comments: this.hotcom } = reponse.data);
          // ({hotComments:this.hotcom} = reponse.data);
        });
    }
  },
  created() {
    window.console.log("创建");
    // this. getComment();
  },
  // watch: {
  //     $route:function(){
  //         window.console.log(this.$route);
  //     }
  // },
  beforeRouteEnter(to, from, next) {
    // window.console.log(to);
    // 路由进入，当前组件实例化之前，就拿数据
    // beforeRouteEnter 守卫 不能 访问 this，
    // 因为守卫在导航确认前被调用,因此即将登场的新组件还没被创建。
    next(vm => {
      vm.getPlayListDetail(to.query.id);
      vm.getComment(to.query.id);
    });
  }
};
</script>

<style lang="less">
.playlist {
  // background: #FAFAFA;
  .go-back {
    margin-left: 5px;
    font-size: 14px;
    color: #c62f2f;
    // border-bottom: 1px solid #666;
  }
}
.slist {
  color: #666;
  font-size: 12px;
  line-height: 20px;
  background: #eeeff0;
  padding: 2px 10px;
}
h3 {
  color: #333;
  font-size: 14px;
  padding-left: 2px;
  border-left: 2px solid #c62f2f;
  line-height: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
